import React, { Component, Fragment } from "react"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import { DevelopmentServices } from "../../../services"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import externalLink from "../../../assets/images/external-link.png"

export default class CadModule extends Component {
  state = {
    _id: "",
    cad: null,
    CAD: {},
    STATUS: [],
    assignedToList: [],
    disabled: false
  }

  componentWillMount() {
    let {
      cad,
      _id,
      CAD,
      assignedToList,
      STATUS,
      disabled,
      cadProcess,
      cadPreFill
    } = this.props
    this.setState({
      _id,
      cad,
      cadProcess,
      CAD,
      assignedToList,
      disabled,
      STATUS,
      cadPreFill
    })

    this.getCADRefNumber("")
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(this.state.CAD).length != Object.keys(nextProps.CAD).length
    ) {
      this.setState({
        CAD: nextProps.CAD
      })
    }

    const {
      cad,
      _id,
      assignedToList,
      STATUS,
      disabled,
      cadProcess,
      cadPreFill
    } = nextProps
    this.setState({
      cad,
      _id,
      assignedToList,
      STATUS,
      disabled,
      cadProcess,
      cadPreFill
    })
  }

  getCADRefNumber = value => {
    DevelopmentServices.getCADRefNumber(value)
      .then(response => {
        if (response.status === 200) {
          this.setState({ CADRefNumInfo: response.text.data })
        }
      })
      .catch(error => { })
  }

  render() {
    const { cad, CAD, assignedToList, STATUS } = this.state
    const { permissions } = this.props
    return (
      <div
        class="card-filter meeting-min-con"
        id="cad"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12 nopadding">
          <ModuleHeader
            header={"3D"}
            moduleName={"cad"}
            process={this.state.cadProcess}
            updateModulesMain={this.props.updateModulesMain}
            onClick={this.onOpenModal}
            _id={this.state._id}
            statusList={STATUS}
            disabled={this.state.disabled}
          />
          <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
            <div class="wash-container">
              <form name="cadForm">
                <Fragment>
                  <div class="col-md-12 no-padding">
                    <div class="col-md-12 no-padding">
                      {/* <div class="col-md-2 step-one pl-0">
                      <div class="form-group">
                        <label for="ref-no">Assigned To</label>
                        <br />
                        <div class="custom-async-select">
                            <Async
                                name="assignedTo"
                                value={cad.assignedTo}
                                // onInputChange={this.getFabricNumber}
                                // onChange={(value) => this.props.getFabricInfo(value,index)}
                                placeholder="Find AssignedTo"
                                options={this.state.assignedToList}
                                disabled = {true}
                            />
                      </div>
                      </div>
                    </div> */}
                      <div class="col-md-2 step-one pl-0">
                        <div class="form-group">
                          <label for="ref-no">3D Ref No.</label>
                          <div className="custom-async-select inline-external">
                            <Async
                              name="cadRefNo"
                              value={cad.cadId}
                              onInputChange={e => this.getCADRefNumber(e)}
                              onChange={value =>
                                this.props.changeCADRefNum(value)
                              }
                              placeholder="Find 3D RefNo"
                              options={this.state.CADRefNumInfo}
                              disabled={this.state.disabled}
                              onSelectResetsInput={false}
                              onBlurResetsInput={false}
                            />
                          </div>
                          <img
                            className={"external-link cursor-hover pl-1"}
                            src={externalLink}
                            onClick={() =>
                              this.props.history.push("/developmentCad", {
                                action: `${this.props.action}`,
                                _id: cad.cadId
                              })
                            }
                          />
                        </div>
                      </div>

                      <div class="col-md-2 step-one pl-0">
                        <div className="form-group">
                          <label for="no">3D NAME</label>
                          <Field
                            isFormGroup={false}
                            inputType="text"
                            inputName="cadName"
                            value={cad.cadName}
                            // index={index}
                            onChange={this.props.cadUpdate}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-2 step-one pl-0">
                        {/* <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="cadType"
                          value={this.state.cadDoneBy}
                          label={"CAD TYPE"}
                          options={CAD.CADTYPE || []}
                          onChange={this.changeCADDoneBy}
                          disabled={this.state.disabled}
                        /> */}
                        <div className="form-group">
                          <label for="no">3D TYPE</label>
                          {/* <ReactMultiSelectCheckboxes
                              value={[]}
                              options={CAD.CADTYPE} /> */}
                          <p>
                            {cad.cadType.map(data => data.label).join(",\n ")}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-2 step-one pl-0">
                        <div className="form-group">
                          <label for="no">PRINT/EMB TYPE</label>
                          <Field
                            isFormGroup={false}
                            inputType="select"
                            inputName="printEmbType"
                            value={cad.printEmbType}
                            options={
                              this.state.cadPreFill
                                ? this.state.cadPreFill.PRINTEMBTYPE
                                : []
                            }
                            // index={index}
                            onChange={this.props.cadUpdate}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-2 step-one pl-0">
                        <div className="form-group">
                          <label for="no">BORDER TYPE</label>
                          <Field
                            isFormGroup={false}
                            inputType="select"
                            inputName="borderType"
                            value={cad.borderType}
                            options={
                              this.state.cadPreFill
                                ? this.state.cadPreFill.BORDERTYPE
                                : []
                            }
                            // index={index}
                            onChange={this.props.cadUpdate}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>

                      {/* <Picky
                            value={cadObj.cadType}
                            className={"picky-custom-width"}
                            options={prefillData.CADTYPE}
                            onChange={val => this._handleChangeCadType(val)}
                            open={false}
                            valueKey="value"
                            labelKey="label"
                            multiple={true}
                            includeSelectAll={true}
                            includeFilter={true}
                            dropdownHeight={300}
                            disabled={this.state.disabled}
                          /> */}
                      {/* <div class="col-md-2 step-one px-0">
                      <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="status"
                          value={cad.status}
                          options={STATUS}
                          index ={index}
                          label ={"Status"}
                          onChange={this.props.updateCadValues}
                          disabled={this.state.disabled}
                        />
                    </div> */}
                      {/* <div class="col-md-2 step-one">
                      <Field
                          isFormGroup={true}
                          inputType="date"
                          inputName="completedDate"
                          label="Date Completed"
                          value={cad.completedDate}
                          index ={index}
                          onChange={this.props.updateCadValues}
                          disabled={this.state.disabled}
                        />
                    </div> */}
                    </div>
                    <div class="col-md-12 step-one px-0">
                      <Field
                        isFormGroup={true}
                        inputType="textarea"
                        inputName="comments"
                        value={cad.comments}
                        label="comments"
                        onChange={this.props.updateCadValues}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  {!this.state.disabled &&
                    (permissions.create || permissions.edit) && (
                      <div class="col-md-12 no-padding text-center profile-btn">
                        <Button
                          onClick={e => this.props.saveCAD(e)}
                          buttonName={"Save"}
                        />
                        <Button
                          onClick={e => this.props.completeCAD(e)}
                          buttonName={"Complete"}
                        />
                      </div>
                    )}
                </Fragment>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/CadModule/index.js